export { default } from "./src/scrollable-cards";

export type { UniformScrollableHeroCardsProps } from "./src/scrollable-cards";
